import {createUseStyles} from "react-jss";
import {input} from "../../theme";

export const useStyles = createUseStyles({
    component: {
        display: "inline-block",
    },
    input: {
       ...input,
    }
});